import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import { forwardRef, chakra } from '@chakra-ui/react';
import { mapResponsive, cx } from '@chakra-ui/utils';
import { useRowContext } from './Row.js';
var _excluded = ["width", "w", "className"];

/**
 * Col
 *
 * A copy of the `Col` element of common CSS frameworks. Accepts fractions as width's.
 */
var Col = forwardRef(function (props, ref) {
  var widthProp = props.width,
    wProp = props.w,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var _useRowContext = useRowContext(),
    spacing = _useRowContext.spacing,
    width = _useRowContext.width;
  var styles = {
    position: 'relative',
    width: '100%',
    pl: spacing,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: mapResponsive(widthProp || wProp || width, function (r) {
      return r > 1 || typeof r === 'string' ? r : "".concat(r * 100, "%");
    }),
    maxWidth: mapResponsive(widthProp || wProp || width, function (r) {
      return r > 1 || typeof r === 'string' ? r : "".concat(r * 100, "%");
    })
  };
  return /*#__PURE__*/React__default.createElement(chakra.div, _extends({
    className: cx("chakra-col", className),
    __css: styles
  }, rest, {
    ref: ref
  }));
});
export { Col };